import {
	BifrostBackendNestApi,
	BifrostBackendViaCdnApiV2
} from "../gateways/BifrostBackendApi.js";
import AppError from "../domains2/libraries/AppError";
import appConfig from "../appconfig";

let featureTogglePromise;
let featureToggles;
const FeatureToggleProvider = {
	getFeatureTogglesAsPromise(
		forceRefresh = false,
		useApiCdnCaching = false,
		useLandingpageEndpoint = false
	) {
		if (useLandingpageEndpoint === true) {
			featureTogglePromise = Promise.resolve({});
		}

		if (!featureTogglePromise || forceRefresh === true) {
			const isSGTenant = appConfig.tenantConfig.isSGTenant === true;
			const isMinified = !isSGTenant; // + any other conditions

			featureTogglePromise = (
				useApiCdnCaching ? BifrostBackendViaCdnApiV2 : BifrostBackendNestApi
			)
				.get(`/intusr/_featureToggles?tenantId=${appConfig.tenantId}${isMinified ? "&minify=true" : "" }`)
				.then((response) => {
					return response.data;
				});
			featureTogglePromise.then((config) => {
				featureToggles = config;
			});
		}
		return featureTogglePromise;
	},
	getFeatureToggles() {
		if (!featureToggles) {
			throw AppError.CodingError().addMessage(
				"This value can only be relied upon if the appconfigPromise has been waited for first. This must be a programming error. "
			);
		} else {
			return featureToggles;
		}
	},

	async setFeatureToggle({ name, value, jwtToken }) {
		await BifrostBackendNestApi.patch(
			`/feature-toggles/${name}`,
			{
				value
			},
			{
				headers: { Authorization: jwtToken }
			}
		);
	}
};

export default Object.freeze(FeatureToggleProvider);
